import { render, staticRenderFns } from "./CarrinhoEmpresa.vue?vue&type=template&id=5fde21d3"
import script from "./CarrinhoEmpresa.vue?vue&type=script&lang=js"
export * from "./CarrinhoEmpresa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports